import { ColorInput } from 'common-front/src/designSystem/components/colorInput';
import { Icon } from 'common-front/src/designSystem/components/icon';
import { IconSelect } from 'common-front/src/designSystem/components/iconSelect';
import { useHeavent } from 'common-front/src/hooks/useHeavent';
import { Flex } from 'common/src/designSystem/components/flex';
import { Accreditation, AccreditationProperty } from 'common/src/generated/types';
import * as React from 'react';
import { AccreditationsUpdateCell } from './accreditationsUpdateCell';

interface IAccreditationsIconColorCellProps {
    accreditation: Pick<Accreditation, 'id' | 'color' | 'icon'>;

    reload(): void;
}

export const AccreditationsIconColorCell = (props: IAccreditationsIconColorCellProps) => {
    const { translate } = useHeavent();
    const initialValue = React.useMemo(
        () => ({
            [AccreditationProperty.Color]: props.accreditation.color,
            [AccreditationProperty.Icon]: props.accreditation.icon
        }),
        [props.accreditation]
    );

    return (
        <AccreditationsUpdateCell
            accreditationId={props.accreditation.id}
            cellCss={{ flex: '0 80px' }}
            initialValue={initialValue}
            property={[AccreditationProperty.Color, AccreditationProperty.Icon]}
            reload={props.reload}
            renderInput={(value: any, setValue) => (
                <Flex direction="column" gap="2" width={1}>
                    <ColorInput
                        label={translate('Color')}
                        value={value[AccreditationProperty.Color]}
                        onChange={(newValue: any) => {
                            setValue({ ...value, [AccreditationProperty.Color]: newValue });
                        }}
                    />

                    <IconSelect
                        label={translate('Icon')}
                        renderOnPortal={true}
                        value={value[AccreditationProperty.Icon]}
                        onChange={(newValue: any) => {
                            setValue({ ...value, [AccreditationProperty.Icon]: newValue });
                        }}
                    />
                </Flex>
            )}
            renderValue={() => (
                <Icon color={props.accreditation.color} icon={props.accreditation.icon} />
            )}
        />
    );
};
